<template>
    <div>
        <div style="padding: 0 20px">
            <div class="top">
                <div>
                    <el-input size="small"
                              placeholder="请输入代理商姓名"
                              suffix-icon="el-icon-search"
                              style="width: 220px;margin-right: 20px"
                              v-model="query.agentName">
                    </el-input>
                    <el-input size="small"
                              placeholder="请输入代理商手机号"
                              suffix-icon="el-icon-search"
                              style="width: 220px;margin-right: 20px"
                              v-model="query.mobile">
                    </el-input>
                </div>
                <div>
                    <el-button type="primary" style="width: 124px" @click="getUser">新增代理商</el-button>
                </div>
            </div>
            <div>
                <el-table :data="tableData"
                          v-loading="loading"
                          :header-cell-style="{'padding-left': '10%'}"
                          :cell-style="{'padding-left': '10%'}">
                    <el-table-column prop="agentName" label="姓名"></el-table-column>
                    <el-table-column prop="mobile" label="手机号"></el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <el-button type="text" @click="openEdit(scope.row)">配置共享药房</el-button>
                            <el-button type="text" class="delete-button" @click="deleteAgent(scope.row)">撤销代理商</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="pagination">
                <el-pagination
                        background
                        layout="total, prev, pager, next"
                        :current-page="pageNum"
                        :page-size="pageSize"
                        :total="total"
                        @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>
        <el-dialog title="新增代理商" :visible.sync="dialogAddVisible" width="700px" :close-on-click-modal="false">
            <div style="text-align: center">
                <el-transfer
                        style="text-align: left; display: inline-block"
                        v-model="userIdList"
                        filterable
                        filter-placeholder="搜索员工姓名"
                        ref="user"
                        :titles="['员工', '当前已选择']"
                        :format="{
                            noChecked: '${total}',
                            hasChecked: '${checked}/${total}'
                         }"
                        :props="{
                            key: 'userId',
                            label: 'realName',
                        }"
                        :data="userList">
                    <span slot-scope="{ option }">{{ option.realName }}</span>
                </el-transfer>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogAddVisible = false" style="width: 76px">取消</el-button>
                <el-button type="primary" @click="confirmAdd" style="width: 76px">确定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="配置共享药房" :visible.sync="dialogEditVisible" width="700px" :close-on-click-modal="false">
            <div style="text-align: center">
                <el-transfer
                        style="text-align: left; display: inline-block"
                        v-model="pharmacyList"
                        filterable
                        filter-placeholder="搜索药房名称"
                        ref="pharmacy"
                        :titles="['共享药房', '当前已配置']"
                        :format="{
                            noChecked: '${total}',
                            hasChecked: '${checked}/${total}'
                         }"
                        :props="{
                            key: 'pharmacyId',
                            label: 'pharmacyName',
                        }"
                        :data="items">
                    <span slot-scope="{ option }">{{ option.pharmacyName }}</span>
                </el-transfer>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogEditVisible = false" style="width: 76px">取消</el-button>
                <el-button type="primary" @click="confirmEdit" style="width: 76px">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                authorization:localStorage.getItem('authorization'),
                query: {
                    agentName: '',
                    mobile: '',
                },
                // 表格信息
                loading: true,
                tableData: [],
                // 分页信息
                pageNum: 1,
                pageSize: 10,
                total: 0,
                // 代理商新增
                dialogAddVisible: false,
                userList: [],
                userIdList: [],
                // 代理商共享药房配置
                dialogEditVisible: false,
                items: [],
                agentId: '',
                pharmacyList: [],
            }
        },
        methods: {
            // 获取代理商列表
            getData() {
                this.loading = true
                let params = {
                    pageNum: this.pageNum,
                    pageSize: this.pageSize,
                    agentName: this.query.agentName,
                    mobile: this.query.mobile,
                }
                this.axios.post('/api-b/10037/100127',params,{
                    headers:{
                        Authorization: this.authorization,
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        if (res.data.data.list.length !== 0) {
                            this.tableData = res.data.data.list
                        } else {
                            this.$message.info('暂无代理商')
                            this.tableData = []
                        }
                        this.total = res.data.data.total
                    } else {
                        this.$message.error(res.data.message)
                        this.total = 0
                        this.tableData = []
                    }
                    this.loading = false
                }).catch(() => {
                    this.total = 0
                    this.tableData = []
                    this.loading = false
                })
            },
            // 表格换页
            handlePageChange(val) {
                this.pageNum = val;
                this.queryDiagnose();
            },
            // 获取员工
            getUser() {
                let params = {
                    pageNum: 1,
                    pageSize: 999,
                }
                this.axios.post('/api-u/10024/100121',params,{
                    headers:{
                        Authorization: this.authorization
                    }
                }).then(res =>{
                    if(res.data.code === 10000) {
                        this.dialogAddVisible = true
                        this.userIdList = []
                        if (res.data.data.list !== null) {
                            this.userList = res.data.data.list
                        } else {
                            this.userList = []
                        }
                    } else {
                        this.$message.error(res.data.message)
                        this.userList = []
                    }
                })
            },
            // 新增代理商
            confirmAdd() {
                let params = {
                    userIdList: this.userIdList
                }
                this.axios.post('/api-b/10037/100153',params,{
                    headers:{
                        Authorization: this.authorization,
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        this.getData()
                        this.$message.success(res.data.message)
                        this.dialogAddVisible = false
                        this.userIdList = []
                        if(this.$refs.user){
                            this.$refs.user.$children["0"]._data.query = '';
                            // 清空右边搜索
                            this.$refs.user.$children["3"]._data.query = '';
                        }
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },
            // 获取共享药房
            getPharmacy() {
                return new Promise((resolve, reject) => {
                    let params = {
                        pageNum: 1,
                        pageSize: 999,
                        pharmacyName: '',
                    }
                    this.axios.post('/api-b/10008/100133',params,{
                        headers:{
                            Authorization: this.authorization,
                        }
                    }).then(res => {
                        if (res.data.code === 10000) {
                            this.items = res.data.data.list
                            resolve()
                        } else {
                            this.$message.error(res.data.message)
                            reject()
                        }
                    }).catch(error => {
                        reject()
                    })
                })
            },
            deleteAgent(data){
                this.axios.put('/api-b/10037/100154/' + data.agentId,'',{
                    headers:{
                        Authorization: this.authorization,
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        this.$message.success(res.data.message)
                        this.getData()
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },
            // 打开配置弹窗
            async openEdit(data) {
                this.agentId = data.agentId
                await this.getPharmacy()
                this.axios.get('/api-b/10037/100137/' + data.agentId,{
                    headers:{
                        Authorization: this.authorization,
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        this.dialogEditVisible = true
                        if (res.data.data.length !== 0) {
                            let list = []
                            for (let i=0; i<res.data.data.length; i++) {
                                list.push(res.data.data[i].pharmacyId)
                            }
                            this.pharmacyList = list
                        } else {
                            this.pharmacyList = []
                        }
                        if(this.$refs.pharmacy){
                            this.$refs.pharmacy.$children["0"]._data.query = '';
                            // 清空右边搜索
                            this.$refs.pharmacy.$children["3"]._data.query = '';
                        }
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },
            // 确认编辑
            confirmEdit() {
                let params = {
                    agentId: this.agentId,
                    pharmacyList: this.pharmacyList
                }
                this.axios.post('/api-b/10037/100128',params,{
                    headers:{
                        Authorization: this.authorization,
                    }
                }).then(res => {
                    if (res.data.code === 10000){
                        this.dialogEditVisible = false
                        this.$message.success(res.data.message)
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },
        },
        watch: {
            query: {
                handler() {
                    this.pageNum = 1
                    clearTimeout(this.timeout)
                    this.timeout = setTimeout(() => {
                        this.getData()
                    },300)
                },
                deep:true
            }
        },
        created() {
            this.getData()
        }
    }

</script>
<style>

</style>
<style scoped>
    .top {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin-top: 12px;
        height: 52px;
    }
    .delete-button {
        margin-left: 20px;
        color: rgba(255,75,75,1) !important;
    }
    .delete-button:hover {
        color: rgba(255,75,75,0.8) !important;
    }
    .delete-button:focus {
        color: rgba(215,37,41,1) !important;
    }
</style>